import React, { useState, useEffect } from 'react';

const PwaInstallBanner = () => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [showBanner, setShowBanner] = useState(false);
    const [isIOS, setIsIOS] = useState(false);

    useEffect(() => {
        // 1. Verificamos si ya la instaló o la cerró antes
        const isDismissed = localStorage.getItem('pwa_dismissed');
        // Validamos si ya se está ejecutando como App nativa
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;

        if (isDismissed || isStandalone) {
            return; 
        }

        // 2. Detección de iOS
        const userAgent = window.navigator.userAgent.toLowerCase();
        const isIosDevice = /iphone|ipad|ipod/.test(userAgent);
        
        if (isIosDevice) {
            setIsIOS(true);
            setTimeout(() => setShowBanner(true), 3000);
        }

        // 3. Detección de Android/Chrome
        const handleBeforeInstallPrompt = (e) => {
            e.preventDefault(); 
            setDeferredPrompt(e);
            setTimeout(() => setShowBanner(true), 3000);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);

    const handleInstallClick = async () => {
        if (deferredPrompt) {
            deferredPrompt.prompt();
            const { outcome } = await deferredPrompt.userChoice;
            if (outcome === 'accepted') {
                console.log('Usuario instaló la PWA');
            }
            setDeferredPrompt(null);
            setShowBanner(false);
        }
    };

    const handleDismiss = () => {
        localStorage.setItem('pwa_dismissed', 'true');
        setShowBanner(false);
    };

    if (!showBanner) return null;

    // Clase dinámica según el SO
    const deviceClass = isIOS ? 'pwaBannerIOS' : 'pwaBannerAndroid';

    return (
        <div className={`pwaBannerWrapper ${deviceClass}`}>
            <div className="pwaBannerCard shadow-sm">
                
                <div className="d-flex justify-content-between align-items-start mb-3">
                    <div className="d-flex align-items-center">
                        <div className="pwaBannerIconBox">
                            <i className="ki-outline ki-screen fs-1 text-primary"></i>
                        </div>
                        <div className="ms-3">
                            <h4 className="m-0 fs-5 fw-bold text-dark">Instalar App</h4>
                            <span className="text-muted fs-8">Top Online [PTP]</span>
                        </div>
                    </div>
                    <button onClick={handleDismiss} className="btn btn-icon btn-sm btn-light btn-color-gray-600 pwaBannerCloseBtn">
                        <i className="ki-outline ki-cross fs-2"></i>
                    </button>
                </div>

                {isIOS ? (
                    <div className="pwaBannerIOSContent">
                        <p className="fs-7 text-gray-700 mb-2">
                            Para instalar en iPhone/iPad, toca <b>Compartir</b> <i className="bi bi-box-arrow-up mx-1"></i> y luego <b>"Agregar a Inicio"</b> <i className="bi bi-plus-square mx-1"></i>.
                        </p>
                        {/* 
                        <div className="pwaBannerVideoPlaceholder">
                            <i className="bi bi-play-circle-fill fs-1 mb-2 text-white"></i>
                            <span className="text-white fw-bold">Video Tutorial (15s)</span>
                            <span className="fs-9 text-gray-400 mt-1">Reemplazar por etiqueta &lt;video&gt;</span>
                        </div>
                        */}
                    </div>
                ) : (
                    <button onClick={handleInstallClick} className="btn btn-primary w-100 fw-bold pwaBannerInstallBtn">
                        <i className="bi bi-download me-2"></i> Instalar Gratis
                    </button>
                )}
            </div>
        </div>
    );
};

export default PwaInstallBanner;